module.exports = __webpack_public_path__ + "static/david-holifield-4SLhp1olvFc-unsplash-055cd563bae62d13d06bbb16a75d4e1f.jpg";